<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-dropdown
      [formControl]="controls.languages"
      label="labels.languages"
      [options]="languages$ | async"
      [multiple]="true"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-dropdown
      [formControl]="controls.technicalSkills"
      label="labels.driverTechnicalSkills"
      [options]="driverTechnicalSkills$ | async"
      [multiple]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-dropdown
      [formControl]="controls.semiTrailers"
      label="labels.semiTrailers"
      [options]="semiTrailerTypes$ | async"
      [multiple]="true"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-tabs
      [formControl]="controls.experienceLevel"
      [tabs]="driverExperienceLevels$ | async"
      label="labels.driverExperienceLevel"
      [fill]="true"
      [size]="32"
      width="100%"
    >
    </onyx-tabs>
  </form>
</onyx-section>
